import type { SelectData } from "@king-ict/eupisi-ui/components";

import { YesNoOption } from "./types";
import { SaveSchoolCandidateInstitutionAssignment } from "../../../models";

export const YES_NO_OPTIONS: SelectData<{ value: YesNoOption; text: string }> = {
  keyProp: "value",
  valueProp: "value",
  textProp: "text",
  data: [
    { value: YesNoOption.Yes, text: "Da" },
    { value: YesNoOption.No, text: "Ne" },
  ],
};


export const DEFAULT_UPDATE_INSTITUTION_ASSIGNMENT: SaveSchoolCandidateInstitutionAssignment = {
  schoolCandidateList: [],
  institutionId: undefined,
};